export enum CustomHttpHeaderName {
  REQUEST_ID = 'x-request-id',
  IGNORE_LOADING = 'x-ignore-loading',
  SKIP_INTERCEPTOR = 'X-Skip-Interceptor',
}
